// React
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Components
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import classNames from 'classnames';
import ErrorIcon from '@material-ui/icons/Error';
import Button from '@material-ui/core/Button';

// HOC
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isPaymentError, clearPaymentError } from 'ducks/error';
import { Routes } from 'constants/pages';

export class NeedPaymentSnackbar extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
  };

  render() {
    const { classes, message, onClose, open } = this.props;
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        onClose={onClose}
      >
        <SnackbarContent
          className={classes.error}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              <ErrorIcon className={classNames(classes.icon, classes.iconVariant)} />
              {message}
            </span>
          }
          action={[
            <Button
              key="close"
              aria-label="Close"
              className={classes.close}
              component={Link}
              to={Routes.InvoiceHistory}
              onClick={onClose}
            >
              Please, setup a payment method
            </Button>,
          ]}
        />
      </Snackbar>
    );
  }
}

const styles = (theme) => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    color: 'white',
  },
});

const mapStateToProps = (state) => ({
  open: isPaymentError(state),
  message: state.error.paymentMessage,
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(clearPaymentError()),
});
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(NeedPaymentSnackbar);
